import { useEffect } from 'react';

import { forceThemeMode } from 'theme/useDarkModeToggle';

/**
 * Shows a wallboard in its own theme (its Dark mode setting) rather than the
 * browser's, while the screen is mounted: every TV looks the same. `null`
 * while the wallboard's settings are still loading.
 */
const useWallboardTheme = ({ theme }: { theme: 'dark' | undefined | null }) => {
  useEffect(() => {
    if (theme === null) {
      return undefined;
    }
    forceThemeMode(theme === 'dark' ? 'dark' : 'light');
    return () => {
      forceThemeMode(undefined);
    };
  }, [theme]);
};

export default useWallboardTheme;
